<div [ngStyle]="divStyle" [ngClass]="divClass"><ng-content></ng-content></div>
